export default __webpack_public_path__ + "static/media/warning--accident-area--g4.e39b418a.png";